"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletSwap = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const applicationSwapperActions = __importStar(require("./redux/WalletSwapWrapperActions"));
const react_redux_2 = require("react-redux");
const ai_1 = require("react-icons/ai");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const ferrum_plumbing_1 = require("ferrum-plumbing");
// import * as SocketActions from "../socket-wrapper/redux/socketWrapperActions";
const WalletSwap = ({ WalletSwapView, WalletSwapViewProps, }) => {
    const [counter, setCounter] = (0, react_1.useState)(1);
    const [statusCounter, setStatusCounter] = (0, react_1.useState)(1);
    const dispatch = (0, react_redux_2.useDispatch)();
    const { toInfo, fromInfo, amount, fee, availableLiquidity, maxBalance, authToken, } = (0, react_redux_1.useSelector)((state) => state.walletApplicationWrapper);
    const { networkClient, walletAddress } = (0, react_redux_1.useSelector)((state) => state.walletConnector);
    const { connectedAlgorandWalletAddress } = (0, react_redux_1.useSelector)((state) => state.algorandWalletConnector);
    const { userProfile } = (0, react_redux_1.useSelector)((state) => state.walletApplicationWrapper);
    const { isSwapping, isSwapped, transactionId, status, swapModalShow, sourceNetwork, } = (0, react_redux_1.useSelector)((state) => state.walletSwapWrapper);
    // console.log("in swap");
    // console.log("fromInfo : ", fromInfo);
    // console.log("toInfo : ", toInfo);
    // console.log("authToken : ", authToken);
    (0, react_1.useEffect)(() => {
        // console.log("counter and transcation id value", counter, transactionId);
        if (counter &&
            transactionId &&
            userProfile &&
            sourceNetwork !== "ALGORAND") {
            // console.log("about to fire checkBlockForTransaction");
            // dispatch(
            //   SocketActions.transactionAdded({
            //     id: transactionId,
            //     userId: userProfile.userId,
            //     event: "swap",
            //   })
            // );
            checkBlockForTransaction();
        }
        // eslint-disable-next-line
    }, [counter, transactionId]);
    (0, react_1.useEffect)(() => {
        if (transactionId &&
            fromInfo &&
            swapModalShow &&
            sourceNetwork !== "ALGORAND") {
            const timer = setTimeout(() => {
                var _a;
                // console.log("This will run after 2 second!", statusCounter);
                dispatch(applicationSwapperActions.getTransactionStatus(transactionId, (_a = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) === null || _a === void 0 ? void 0 : _a.currency.split(":")[0], authToken));
                // console.log("checking success status");
                if (status !== "successful") {
                    // console.log("checking Not-success status");
                    setStatusCounter(statusCounter + 1);
                    // clearTimeout(timer);
                }
            }, 2000);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line
    }, [transactionId, statusCounter]);
    // useEffect(() => {
    //   console.log("counter and swap status", counter, status);
    //   if (counter && status) {
    //     console.log("about to fire check the swap status");
    //     checkSwapTransactionStatus();
    //   }
    //   // eslint-disable-next-line
    // }, [counter, status]);
    // const checkSwapTransactionStatus = async () => {
    //   console.log("checking swap status");
    //   if (status !== "successful") {
    //     try {
    //       await delay(3000);
    //       console.log(
    //         "update swap transaction status when unsuccessfull",
    //         status
    //       );
    //       dispatch(
    //         applicationSwapperActions.getTransactionStatus(
    //           transactionId,
    //           fromInfo?.token?.currency.split(":")[0]
    //         )
    //       );
    //       console.log("current counter value : ", counter);
    //       if (counter === undefined) {
    //         console.log("counter was undefined set it to 1");
    //         setCounter(1);
    //       } else {
    //         console.log("current counter value : ", counter);
    //         console.log("updating counter  value by 1");
    //         setCounter(counter + 1);
    //       }
    //     } catch (ex) {
    //       setCounter(undefined);
    //       console.log("Error while looking up swap status", ex);
    //     }
    //   }
    // };
    const onSwap = () => {
        var _a, _b, _c;
        if ((toInfo === null || toInfo === void 0 ? void 0 : toInfo.token) && (fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) && authToken) {
            // console.log("swapping for : ");
            // console.log("amount : ", amount);
            // console.log("fee : ", fee);
            // console.log("maxBalance : ", maxBalance);
            // console.log("availableLiquidity : ", availableLiquidity);
            // if (amount <= 0.000001) {
            const errors = validateBeforeSwap({
                fromInfo,
                toInfo,
                amount,
                fee,
                maxBalance,
                availableLiquidity,
            });
            if (errors === null || errors === void 0 ? void 0 : errors.length) {
                react_hot_toast_1.default.error(errors[0]);
                // console.log(errors);
            }
            else {
                // console.log("going to swap");
                if (networkClient) {
                    dispatch(applicationSwapperActions.startSwap());
                    if (((_a = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.network) === null || _a === void 0 ? void 0 : _a.networkName) === "ALGORAND") {
                        dispatch(applicationSwapperActions.fromNonEVMToEVMSwap(fromInfo, amount, toInfo, connectedAlgorandWalletAddress, walletAddress, ferrum_plumbing_1.Networks.for(toInfo.network.networkName).chainId, authToken));
                    }
                    else if (((_b = toInfo === null || toInfo === void 0 ? void 0 : toInfo.network) === null || _b === void 0 ? void 0 : _b.networkName) === "ALGORAND") {
                        dispatch(applicationSwapperActions.fromEVMToNonEVMSwap(fromInfo, amount, toInfo, walletAddress, connectedAlgorandWalletAddress, authToken, networkClient));
                    }
                    else {
                        dispatch(applicationSwapperActions.performSwap((_c = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) === null || _c === void 0 ? void 0 : _c.currency, amount.toString(), toInfo === null || toInfo === void 0 ? void 0 : toInfo.token.currency, authToken, networkClient));
                    }
                }
            }
            // const currentCurrency = toInfo?
            // } else {
            //   console.log("please come down");
            // }
        }
    };
    const validateBeforeSwap = ({ fromInfo, toInfo, amount, fee, maxBalance, availableLiquidity, }) => {
        var _a, _b;
        let errors = [];
        const sourceCurrency = (_a = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) === null || _a === void 0 ? void 0 : _a.currency;
        const targetCurrency = (_b = toInfo === null || toInfo === void 0 ? void 0 : toInfo.token) === null || _b === void 0 ? void 0 : _b.currency;
        // if(maxBalance < fee){
        //   errors.push("Not enough balance for this transaction");
        // }
        if (!sourceCurrency.includes("ALGORAND") && maxBalance < amount) {
            errors.push("Not enough balance for this transaction");
        }
        if (sourceCurrency.toLowerCase() === targetCurrency.toLowerCase()) {
            errors.push("Source and target networks cannot be the same");
        }
        if (amount <= 0) {
            errors.push("Swap amount should be greater than 0");
        }
        return errors;
    };
    const checkBlockForTransaction = () => __awaiter(void 0, void 0, void 0, function* () {
        // console.log("checking chain for transaction");
        if (transactionId && sourceNetwork !== "ALGORAND") {
            try {
                const transaction = yield (networkClient === null || networkClient === void 0 ? void 0 : networkClient.eth.getTransaction(transactionId));
                // console.log("Checking the transloota ", transaction);
                if (transaction && transaction.blockNumber) {
                    // console.log("Translo iso componte ", transaction);
                    dispatch(applicationSwapperActions.swapFound());
                    //dipatch here that swapped is found on block;
                }
                else {
                    // console.log("transction not found on block wait 3000ms and try again");
                    yield delay(3000);
                    // console.log("current counter value : ", counter);
                    if (counter === undefined) {
                        // console.log("counter was undefined set it to 1");
                        setCounter(1);
                    }
                    else {
                        // console.log("current counter value : ", counter);
                        // console.log("updating counter  value by 1");
                        setCounter(counter + 1);
                    }
                }
            }
            catch (ex) {
                setCounter(undefined);
                // console.log("Error while looking up transaction on block", ex);
                dispatch(applicationSwapperActions.swapFailed());
                //dispatch here that approval is failed
            }
        }
    });
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(WalletSwapView, Object.assign({ prefix: isSwapping ? react_1.default.createElement(ai_1.AiOutlineLoading3Quarters, null) : undefined, title: "Swap" }, WalletSwapViewProps, { onClick: () => onSwap(), disabled: isSwapping || isSwapped }))));
};
exports.WalletSwap = WalletSwap;
//# sourceMappingURL=WalletSwap.js.map